import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'bn-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, ButtonComponent],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <bn-button appearance="raised" (click)="dialogRef.close(false)">
        {{ data.cancelText || 'Cancel' }}
      </bn-button>
      <bn-button
        appearance="raised"
        color="warn"
        (click)="dialogRef.close(true)"
      >
        {{ data.confirmText || 'Confirm' }}
      </bn-button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      p {
        color: var(--md-sys-color-on-surface);
        margin: 0;
      }
      mat-dialog-actions {
        gap: 0.5rem;
      }
      mat-dialog-content {
        min-width: 300px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
}
